import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.mainFooter}>
          <div className={styles.brand}>
            <div className={styles.brandSection}>
              <img 
                src={process.env.PUBLIC_URL + '/images/neural-lab-logo-white.png'} 
                alt="Neural Lab" 
                className={styles.logoImage}
              />
              <div className={styles.brandName}>Neural Lab</div>
            </div>
            <div className={styles.partnerInfo}>
              <p className={styles.partnerText}>Supported by</p>
              <img 
                src={process.env.PUBLIC_URL + '/images/hkstp_white.png'} 
                alt="HKSTP Partner" 
                className={styles.partnerLogo}
              />
            </div>
            <p className={styles.brandDescription}>
              Reimagining airport operations with AI. Empowering airports to leverage artificial intelligence for seamless and future-ready operations.
            </p>
            <div className={styles.socialLinks}>
              <a href="https://www.linkedin.com/company/neural-lab/posts/?feedView=all" className={styles.socialLink} aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="mailto:bd@neurallab.co" className={styles.socialLink} aria-label="Email">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className={styles.sectionTitle}>Quick Links</h3>
            <ul className={styles.links}>
              <li className={styles.link}><Link to="/">Home</Link></li>
              <li className={styles.link}><Link to="/about-us">About Us</Link></li>
              <li className={styles.link}><Link to="/case-studies">Case Studies</Link></li>
              <li className={styles.link}><Link to="/news-insights">News & Insights</Link></li>
              <li className={styles.link}><Link to="/careers">Careers</Link></li>
              <li className={styles.link}><Link to="/ops-assist">OpsAssist</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className={styles.sectionTitle}>Our Locations</h4>
            <div className={styles.addresses}>
              <div className={styles.address}>
                <h4 className={styles.addressLabel}>Singapore – HQ</h4>
                <p className={styles.addressText}>
                  65 Airport Boulevard, #03-37<br />
                  Changi Airport Terminal 3<br />
                  Singapore, 819663
                </p>
              </div>
              <div className={styles.address}>
                <h4 className={styles.addressLabel}>Hong Kong</h4>
                <p className={styles.addressText}>
                  417A, Innocenter<br />
                  72 Tat Chee Avenue<br />
                  Kowloon Tong, Hong Kong
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className={styles.bottomBar}>
          <div className={styles.copyright}>
            © 2025 Neural Lab. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
